import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import "antd/dist/antd.css";
import { ShareAltOutlined } from '@ant-design/icons';
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";
import './ShareModal.css';

export const ShareModal = ({ shareUrl }) => {
  const isMobile=window.screen.width<768
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [privacy, setPrivacy] = useState(0);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setPrivacy(0);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPrivacy(0);
  };

  return (
    <>
      {/* <Button type="primary" onClick={showModal} style={{ backgroundColor: '#1a5669', border: '1px solid #1a5669' }}> */}
      <Tooltip title="Share" placement="bottom">
        <button
          onClick={showModal}
          aria-label="Share"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            height: '30px',
            padding: isMobile ? '0 10px' : '0 14px',
            background: 'transparent',
            border: '1.5px solid #526bb1',
            borderRadius: '6px',
            color: '#526bb1',
            fontSize: '12px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.12s ease',
            letterSpacing: '0.01em',
            flexShrink: 0,
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#526bb1'; e.currentTarget.style.color = 'white'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#526bb1'; }}
        >
          <ShareAltOutlined style={{ fontSize: '13px' }} />
          {!isMobile && 'Share'}
        </button>
      </Tooltip>
      {/* <span style={{fontWeight: "500", letterSpacing: "0.5px"}}>Share</span> */}
      {/* </Button> */}
      <Modal
        title="Share with people and Groups"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        className="share-doc-modal"
      >
        <ShareModalContent shareUrl={shareUrl} setIsModalVisible={setIsModalVisible} privacy={privacy} setPrivacy={setPrivacy} />
      </Modal>
    </>
  );
};
